import React from 'react';

import { useTheme } from '@mui/material/styles';

function MoreIcon() {
    const theme = useTheme();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
            <path fill={theme.palette.icons.color} d="M8 2c-.734 0-1.333.6-1.333 1.333 0 .734.6 1.334 1.333 1.334s1.333-.6 1.333-1.334C9.333 2.6 8.733 2 8 2Zm0 9.333c-.734 0-1.333.6-1.333 1.334C6.667 13.4 7.266 14 8 14s1.333-.6 1.333-1.333c0-.734-.6-1.334-1.333-1.334Zm0-4.666c-.734 0-1.333.6-1.333 1.333S7.266 9.333 8 9.333 9.333 8.733 9.333 8 8.733 6.667 8 6.667Z" />
        </svg>
    );
}

export default MoreIcon;
